import React, { useState } from "react";
import CampaignNotificationsScreen from "./CampaignNotificationsScreen";
import CampaignUsersScreen from "./CampaignUsersScreen";
import { ROUTES } from "./Route";

export default function CampaignNotifications() {
  const [page, setPage] = useState(ROUTES.LIST);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [audience, setAudience] = useState("sent");

  switch (page) {
    case ROUTES.USERS:
      return (
        <CampaignUsersScreen
          campaign={selectedCampaign}
          initialAudience={audience}
          setPage={setPage}
          setAudience={setAudience}
        />
      );
    case ROUTES.LIST:
    default:
      return (
        <CampaignNotificationsScreen
          setPage={setPage}
          setSelectedCampaign={setSelectedCampaign}
          setAudience={setAudience}
        />
      );
  }
}
